module.exports = __webpack_public_path__ + "./img-huichen_4daabe0d1f4a92f456f8882590188e06.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/img-huichen.png
// module id = 463
// module chunks = 0